import './AuthInvitationCode.css';
import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { getDictionaryItem, get } from '../../../../utils';
import Loader from '../../../DAcApplication/components/loader';
import { runValidations, validateRequired, validateEmail, validateLength, validateAlphanumeric } from '../../../Login/commomFunctions';
import FormField from '../../../Login/components/FormField';
import { IconMiniInfo } from '../../../atoms/Icons';
import { INVITATION_CODE_LENGTH, INVITATION_SUBMIT_LIMIT } from '../constants';
const AuthInvitationCode = _ref => {
  let {
    dictionary,
    configuration,
    apiConfig,
    sessionId,
    hide,
    callAfterSubmit,
    rtl,
    username
  } = _ref;
  const [disableSubmit, setDisableSubmit] = useState(true);
  const [authInvitationLoader, setAuthInvitationLoader] = useState(false);
  const [invitationSubmitLimit, setInvitationSubmitLimit] = useState(Number(sessionStorage.getItem('authInvitationSubmitLimit')) || 0);
  const [email, setEmail] = useState('');
  const [errorEmail, setErrorEmail] = useState('');
  const emailFieldProps = {
    value: email,
    fieldError: errorEmail,
    setError: setErrorEmail,
    label: getDictionaryItem(dictionary, 'emailAddress'),
    type: 'email',
    id: 'autInvitationEmail',
    name: 'autInvitationEmail',
    placeholder: '',
    labelLight: false,
    // maxLength: defaultMaxLength,
    errorRequired: getDictionaryItem(dictionary, 'emailRequired') || ' ',
    errorValue: getDictionaryItem(dictionary, 'emailIsNotValid') || ' ',
    errorValidation: getDictionaryItem(dictionary, 'emailValidationError') || ' ',
    successValidation: getDictionaryItem(dictionary, 'emailValidationSuccess') || ' ',
    autoComplete: 'email',
    required: true,
    requiredFromContent: true,
    changeEvent: value => {
      setEmail(value);
    },
    blurEvent: value => {
      emailFieldProps.validate(value);
    },
    validate: function () {
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : email;
      return runValidations([validateRequired, validateEmail], value, emailFieldProps);
    }
    // focusEvent: formFillAnalytics
  };
  const [authInvitationCode, setAuthInvitationCode] = useState('');
  const [errorAuthInvitationCode, setErrorAuthInvitationCode] = useState(invitationSubmitLimit === INVITATION_SUBMIT_LIMIT ? getDictionaryItem(dictionary, 'invitationSubmitLimit') : '');
  const invitationCodeFieldProps = {
    value: authInvitationCode,
    fieldError: errorAuthInvitationCode,
    setError: setErrorAuthInvitationCode,
    label: getDictionaryItem(dictionary, 'invitationCode'),
    type: 'text',
    id: 'authInvitationCodeCreate',
    name: 'authInvitationCodeCreate',
    placeholder: '',
    labelLight: false,
    errorRequired: getDictionaryItem(dictionary, 'invitationCodeRequired') || ' ',
    errorValue: getDictionaryItem(dictionary, 'invitationCodeInvalid') || ' ',
    requiredLength: INVITATION_CODE_LENGTH,
    autoComplete: 'off',
    required: true,
    requiredFromContent: true,
    isDisabled: invitationSubmitLimit === INVITATION_SUBMIT_LIMIT,
    changeEvent: value => {
      setAuthInvitationCode(value);
    },
    blurEvent: value => {
      invitationCodeFieldProps.validate(value);
    },
    validate: function () {
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : authInvitationCode;
      const validationResult = runValidations([validateRequired, validateLength, validateAlphanumeric], value, invitationCodeFieldProps);
      return validationResult;
    }
  };
  const authInvitFormSubmit = async event => {
    event.preventDefault();
    if (invitationSubmitLimit === INVITATION_SUBMIT_LIMIT) return;
    setAuthInvitationLoader(true);
    setErrorAuthInvitationCode('');
    const tokken = Cookies.get('token');
    // const userNameCookie = Cookies.get('username');

    const url = `${apiConfig.apiUrl}/v1/orc/invitationcodes/verify`;
    const headers = new Headers();
    headers.append('X-Request-Id', sessionId);
    headers.append('Apikey', apiConfig.apiKey);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Methods', 'GET,HEAD,POST,OPTIONS');
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Authorization', tokken || '');
    headers.append('Host', 'dacqa.detsandbox.com');
    headers.append('User-Agent', 'Apidog/1.0.0 (https://apidog.com)');
    const data = {
      invitationCode: authInvitationCode,
      email: email,
      username: username
    };
    const requestOptions = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(data)
    };
    let runIncrement = true;
    await fetch(url, requestOptions).then(response => {
      return response.json();
    }).then(result => {
      if (result.hasOwnProperty('desc')) {
        setErrorAuthInvitationCode(rtl && result.desc.ar ? result.desc.ar : result.desc.en || '');
      }
      if (result.hasOwnProperty('status') && result.status === true) {
        runIncrement = false;
        sessionStorage.removeItem('authInvitationSubmitLimit');
        callAfterSubmit();
      }
    }).catch(error => {
      setErrorAuthInvitationCode(error.message);
      console.error('validateUserRegistrationWithEmail error', error);
    }).finally(() => {
      setAuthInvitationLoader(false);
      runIncrement && setInvitationSubmitLimit(prev => {
        const result = prev + 1;
        if (result === INVITATION_SUBMIT_LIMIT) {
          setErrorAuthInvitationCode(prev => {
            return `${prev} \n ${getDictionaryItem(dictionary, 'invitationSubmitLimit')}`;
          });
        }
        sessionStorage.setItem('authInvitationSubmitLimit', String(result));
        return result;
      });
    });
  };
  useEffect(() => {
    if (email && !errorEmail && authInvitationCode && !errorAuthInvitationCode) {
      setDisableSubmit(false);
    } else {
      setDisableSubmit(true);
    }
  }, [email, errorEmail, authInvitationCode, errorAuthInvitationCode]);
  return /*#__PURE__*/React.createElement("form", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} dac-login-form dac-login-form--auth-invitation-code`,
    onSubmit: event => authInvitFormSubmit(event)
  }, /*#__PURE__*/React.createElement("div", {
    className: "row dac-login-form__inputs"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4 offset-lg-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: `form-elements-wrap ${errorEmail ? 'invalid-field' : ''}`
  }, /*#__PURE__*/React.createElement(FormField, emailFieldProps), /*#__PURE__*/React.createElement("div", {
    className: "invitation-email-info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "invitation-email-info__icon"
  }, /*#__PURE__*/React.createElement(IconMiniInfo, null)), /*#__PURE__*/React.createElement(RichText, {
    tag: "div",
    className: "invitation-email-info__text",
    field: {
      value: get(configuration, 'invitationSectionInformation.jss.value')
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4 "
  }, /*#__PURE__*/React.createElement("div", {
    className: `form-elements-wrap ${errorAuthInvitationCode ? 'invalid-field' : ''}`
  }, /*#__PURE__*/React.createElement(FormField, invitationCodeFieldProps))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group lr__form-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-label visibility-hidden d-none d-lg-block"
  }, getDictionaryItem(dictionary, 'btnVerify')), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary dac-login-form__submit",
    type: "submit",
    disabled: disableSubmit || authInvitationLoader || invitationSubmitLimit === INVITATION_SUBMIT_LIMIT
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      opacity: authInvitationLoader ? 0 : 1
    }
  }, getDictionaryItem(dictionary, 'btnVerify')), authInvitationLoader ? /*#__PURE__*/React.createElement(Loader, null) : false)))));
};
export default AuthInvitationCode;
const commonStyles = "ck8v6ow";
const rtlStyles = "r4e76ca";
const ltrStyles = "l1c59keu";